import { FC, useContext } from "react";
import { AppContext } from "../../App";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const ProjectCard: FC<{
  project: {
    imageURL: string;
    name: string;
    link: string;
    description?: string;
  };
}> = ({ project }) => (
  <div key={project.name} className="project-card">
    <div className="image-wrapper">
      <img
        src={project.imageURL}
        alt={`Скріншот проекту ${project.name}`}
        className="carousel-image"
      />
    </div>
    <a
      href={project.link}
      target="_blank"
      rel="noreferrer"
      className="project-link"
    >
      <p className="legend project-title">{project.name}</p>
    </a>
    {project.description && (
      <p className="project-description">{project.description}</p>
    )}
  </div>
);

export const Portfolio:FC = () => {
  const { userInfo } = useContext(AppContext);

  if (!userInfo || !userInfo.portfolio || userInfo.portfolio.length === 0) {
    return null;
  }

  const { navigation, portfolio } = userInfo;
  const [title, id] = navigation[3];

  return (
    <section id={id} className="portfolio-section">
      <div className="carousel-box">
        <h2 className="title section-title">{title}</h2>
        <Carousel
          autoPlay={true}
          centerMode={true}
          showThumbs={false}
          infiniteLoop={true}
          showStatus={false}
          interval={5000}
          className="portfolio-carousel"
        >
          {portfolio.map((project) => (
            <ProjectCard key={project.name} project={project} />
          ))}
        </Carousel>
      </div>
    </section>
  );
};
